var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "flex v-center"
  }, [_c('span', [_vm._v(_vm._s(_vm.organization))]), _vm._v(" "), _c('span', [_vm._v("Versão " + _vm._s(_vm.version))])])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5d1895a8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d1895a8","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./application/views/commons/footer.vue
// module id = 262
// module chunks = 3